<template>
  <div class="bg-white rounded-lg shadow-md p-4">
    <div class="flex justify-end items-center">
      <v-btn text @click="closeUserDetails">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="p-4">
      <div class="font-bold text-lg text-center">
        USER DETAILS
      </div>
      <div v-for="(item, key, i) in userInfo" :key="i">
        <div v-if="key != 'id'" class="flex">
          <div class="w-[400px] border-gray-400 border-2 px-2">
            {{ key }}
          </div>
          <div class="border-gray-400 border-2 px-2 w-full">
            <div v-if="(key === 'last_password_reset' || key === 'user_last_signed_in') && item">
              {{ moment(item)}} <!-- Specify the format here -->
            </div>
            <div v-else>
              {{ item || '-' }}
            </div>
          </div>
        </div>
      </div>
      <div class="pt-4 text-center">
        <v-btn color="orange" v-if="userInfo.user_password" @click="openPortal"
          >Open Portal</v-btn
        >
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    userDetails: {
      type: Array,
      required: true,
    },
    userEmail: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      userInfo: [],
      // You can add any local state variables here if needed
    };
  },
  computed: {
    // You can add computed properties to manipulate or format userDetails if needed
  },
  watch: {
    userDetails: {
      handler(e) {
        if (e[0]) {
          this.userInfo = e[0];
        }
      },
      immediate: true,
    },
  },
  methods: {
    openPortal() {
      const email = this.userEmail;
      const password = this.userInfo.user_password;
      const url = `https://moldexrealty-buyersportal.com`;

      const newWindow = window.open(url, "_blank"); // Open in a new tab

      // Wait for the new window to load
      newWindow.onload = () => {
        // Use setTimeout to ensure the page is fully loaded
        setTimeout(() => {
          const emailInput = newWindow.document.querySelector(
            'input[name="email"]'
          ); // Adjust the selector as needed
          const passwordInput = newWindow.document.querySelector(
            'input[name="password"]'
          ); // Adjust the selector as needed

          if (emailInput && passwordInput) {
            emailInput.value = email; // Set email
            passwordInput.value = password; // Set password
            newWindow.document.querySelector("form").submit(); // Submit the form if necessary
          } else {
            console.error("Input fields not found");
          }
        }, 1000); // Adjust the timeout as necessary
      };
    },
    moment(f) {
      return moment(f).format("LLL");
    },
    closeUserDetails() {
      this.$emit("closeUserDetails");
    },
  },
};
</script>
